export default __webpack_public_path__ + "static/media/left_slightly_flatFoot.2d1c9204.png";